<template>
  <v-container
    fluid
    class="qmkey-menus-view"
  >
    <v-row
      dense
      class="d-flex mb-0 pb-0"
      style="height: 50px"
    >
      <!-- View Title -->
      <v-col class="d-flex mt-1 mb-0 pb-0 ml-2" md="auto">
        <ViewTitle title="Menus" />
      </v-col>
      <v-col class="d-flex mb-0 pb-0" >
        <v-btn
          rounded
          class="add-button"
          @click.stop="addMenuForm()"
          >
            Add Menu
        </v-btn>
        <v-btn
          v-if="(this.sitePath.split('/').length > 2) && (menus.length == 0)"
          rounded
          small
          class="copy-button font-weight-bold"
          @click.stop="copyParentMenus()"
          >
            Copy Parent Menus
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      fixed
      small
      :items="menus"
      :headers="fields"
      dense
      item-class="qmkey-item-row"
    >
      <template v-slot:item.name="{ item }">
        <v-btn
          @click.stop="editMenuForm(item.id)"
          text
          small
          class="qmkey-add-button-menu"
          :class="!item.parent ? 'menu_root font-weight-bold' : ''"
        >
          {{ menuTitle(item) }}
        </v-btn>
      </template>
      <template v-slot:item.enabled="{item}">
        <b v-if="item.enabled" class="text-success">✔</b>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click.stop="editMenuForm(item.id)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click="addMenuForm(item.id)"
        >
          mdi-plus
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click.stop="deleteMenuForm(item.id)"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>
    <!-- Add /edit dialog -->
    <v-dialog max-width="600px" v-model="showEdit">
      <v-card
        class="mx-auto"
        :loading="loading">
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn
            text @click="close"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle
          class="pb-0"
          v-if="modalSubTitle"
        >
          {{ modalSubTitle }}
        </v-card-subtitle>
        <v-card-text>
          <v-form
            ref="editMenu"
            v-model="valid"
            autocomplete="off"
          >
            <v-alert
              :value="alert"
              color="error"
              dark
              icon="mdi-alert"
              transition="scale-transition"
              outlined
              dismissible
            >
              {{ message }}
            </v-alert>
            <v-text-field
              id="menuname"
              v-model="currentMenu.name"
              type="text"
              required
              placeholder="Enter Menu Name"
              label="Menu name"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              id="menuorder"
              v-model="currentMenu.order"
              type="text"
              required
              placeholder="Enter menu order position"
              label="Order"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              id="menuparent"
              v-model="currentMenu.parent"
              type="text"
              required
              placeholder="Enter parent menu ID"
              label="Parent menu"
            ></v-text-field>
            <v-text-field
              id="menuurl"
              v-model="currentMenu.url"
              type="text"
              required
              placeholder="Enter Menu URL"
              label="Menu url"
            ></v-text-field>
            <v-checkbox
                v-model="currentMenu.enabled"
                label="Is Enabled"
            >
            </v-checkbox>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-4"
            @click="processForm"
            :disabled="!valid"
          >
            Ok
          </v-btn>
          <v-btn @click="clear">Clear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="500px" v-model="showDelete">
      <v-card
        class="mx-auto"
        :loading="loading"
        >
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
        </v-card-title>
        <v-card-text>
          Do you want to delete menu 
          <strong>{{currentMenu.name}}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" @click="processDelete">Ok</v-btn>
          <v-btn @click="showDelete=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import ViewTitle from '@/components/ViewTitle'
import Site from '@/api/Site'
import Menu from '@/api/QMenuItem'

export default {
  name: 'MenusView',
  components: {
    ViewTitle,
  },

  data() {
    return {
      fields: [
        { value: 'name', text: 'Name' },
        { value: 'order', text: 'Order' },
        { value: 'url', text: 'URL' },
        { value: 'enabled', text: 'Enabled' },
        { value: 'actions', text: '', sortable:false },
      ],
      message: null,
      modalTitle: null,
      showDelete: false,
      showEdit: false,
      rules: {
        required: value => !!value || "Required.",
      },
      loading: false,
      modalSubTitle: '',
      alert: false,
      valid: false,
    }
  },

  computed: {
    ...mapState(['isLoading', 'sitePath']),
    ...mapState('QMenu', ['currentMenu', 'error', 'menus']),
  },

  mounted: function() {
    this.SET_CURRENT_SITE(this.$session.get('site'))
    this.GET_MENUS()
  },

  methods: {
    ...mapActions('QMenu', [
      'ADD_MENU',
      'DELETE_MENU',
      'GET_MENU',
      'GET_MENUS',
      'UPDATE_MENU',
      'COPY_FROM_PARENT',
    ]),
    ...mapMutations('QMenu', ['SET_CURRENT_MENU']),
    ...mapMutations(['SET_CURRENT_SITE', 'SHOW_ALERT']),

    // Helper to display Menu name
    menuTitle(data) {
      return '- - '.repeat(data.indent) + data.name
    },

    // Forms
    addMenuForm(parent_id) {
      let currentMenu = {}
      this.modalTitle = 'Add new menu'
      console.log('parent_id', parent_id)
      if (parent_id !== undefined) {
        currentMenu.parent = parent_id
        this.modalTitle = 'Add new submenu'
      }
      this.SET_CURRENT_MENU(currentMenu)
      this.showEdit = true
    },

    async editMenuForm(id) {
      this.message = null
      this.SET_CURRENT_MENU({})
      try {
        await this.GET_MENU(id)
        this.modalTitle = `Edit menu #${id}`
        this.showEdit = true
      } catch (error) {
        // this.SHOW_ALERT(`Error ${error.response.status} getting menu ${id}`)
        this.render_form_errors(error)
        this.alert = true
      }
    },

    async deleteMenuForm(id) {
      this.message = null
      try {
        await this.GET_MENU(id)
        this.modalTitle = `Delete Menu #${id}`
        this.showDelete = true
      } catch (error) {
        this.SHOW_ALERT(`Error ${error.response.status} getting menu ${id}`)
      }
    },

    async processForm(evt) {
      if (evt) evt.preventDefault()
      this.message = null
      try {
        if (this.currentMenu.id !== undefined) {
          await this.UPDATE_MENU(this.currentMenu)
        } else {
          await this.ADD_MENU(this.currentMenu)
        }
        this.showEdit = false
      } catch (error) {
        this.render_form_errors(error)
        this.alert = true
      }
    },

    async processDelete(evt) {
      if (evt) evt.preventDefault()
      try {
        await this.DELETE_MENU(this.currentMenu)
        this.showDelete = false
      } catch (error) {
        this.render_form_errors(error)
      }
    },
    async copyParentMenus() {
      try {
        await this.COPY_FROM_PARENT()
      } catch (error) {
        this.render_form_errors(error)
      }
    },
    clear: function() {
      this.message = '';
      this.alert = false;
      this.$refs.editMenu.resetValidation()
      this.currentMenu = {}
    },
    close: function() {
      this.$refs.editMenu.reset()
      this.message = '';
      this.alert = false;
      this.showEdit = false
      },
  },
}
</script>


<style lang="scss">
  @import "@/sass/menus.scss";
</style>
